// extracted by mini-css-extract-plugin
export default {"root":"ItemName__root--2nuL1","loading":"ItemName__loading--3MQm0"};